import type { FormCreateAccount, FormUpdateAccount } from '@/types/form'
import type { Account, Disk } from '@prisma/client'

import axios from '../axios'
import { tryCatch } from '../catch'

type AccountWithDisks = Account & { disks: Disk[] }

export class UserService {
  static async findAll(query: BaseQuery) {
    try {
      const response = await axios.get<IPaginate<Account>>(`/users`, { params: query })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`UserService.findAll`', error)
    }
  }

  static async findOne(id: number) {
    try {
      const response = await axios.get<AccountWithDisks>(`/users/${id}`)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`UserService.findOne`', error)
    }
  }

  static async create(data: FormCreateAccount) {
    try {
      const response = await axios.post<IResponse>(`/users`, data)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`UserService.create`', error)
    }
  }

  static async update(id: number, data: FormUpdateAccount) {
    try {
      const response = await axios.patch<IResponse>(`/users/${id}`, data)
      return response.data
    } catch (error) {
      tryCatch('`UserService.update`', error)
    }
  }

  static async delete(id: number) {
    try {
      const response = await axios.delete<IResponse>(`/users/${id}`)
      return response.data
    } catch (error) {
      tryCatch('`UserService.delete`', error)
    }
  }

  static async findDocsAll(query: BaseQuery) {
    try {
      const response = await axios.get<IPaginate<Disk & { account: Account }>>(`/disks`, { params: query })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`UserService.findDocsAll`', error)
    }
  }
}
